import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import * as React from "react";
export const UiGrid = React.forwardRef((props, ref) => (_jsx(Grid, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_grid.js.map